export default "__VITE_ASSET__C$1Ue5J4__"